module.exports = __webpack_public_path__ + "img/3.020830a2.png";